/* 趙雲（字子龍） */
import { defineHero, U } from '../define.ts';

export default defineHero({
  id: 'zhaoyun', name: '趙雲', sub: '字子龍', faction: 'shu', role: '戰士/刺客', weapon: 'spear',
  look: {
    statRole: '刺客', // 2026-10-06：敏將（單槍入曹營）；屬性成長照刺客，定位、技能不變
    weaponName: '龍膽亮銀槍', skin: '#f1cba2', hair: '#1d1a1c', fx: '#cfe6ff',
    c: { armor: '#e3e7ec', sleeve: '#3e7b50', cloth: '#35684a', trim: '#d9b45c', pants: '#2d3b33', boot: '#cfd5dc', cape: '#f0f2f5', belt: '#3e7b50', metal: '#e8ecf0', plume: '#d23a2e', pole: '#e9edf1' },
  },
  skills: [
    ['長槍突刺', 'multi', '猛力一刺，造成 {115/175/230/290} 傷害、擊退目標並暈眩 2.5 秒。', { x: { k: 'nuke', dmg: [115, 175, 230, 290], cc: { stun: 2.5, knockback: 150 }, fx: 'slam' }, aim: U(150), cd: 18, mp: 140 }],
    ['橫掃千軍', 'passive', '普攻把 {30/45/60/75}% 傷害擴散給目標附近的敵人。', { pv: { cleave: [30, 45, 60, 75] } }],
    ['無想轉生', 'passive', '{10/20/30/40}% 機率閃避普攻（箭塔也會打空）。', { pv: { evade: [10, 20, 30, 40] } }],
    ['無雙', 'buff', '攻速 +{100/130/160}%、移速 +{25/32/40}%，持續 20 秒。', { x: { k: 'buff', as: [100, 130, 160], ms: [25, 32, 40], dur: 20 }, cd: 120 }],
  ],
});
